export const OPT_OUT_TEXT = "Reply STOP to opt out.";

const OPT_OUT_LINE = /^reply stop to (opt out|unsubscribe)\.?$/i;

const isOptOutLine = (line) => OPT_OUT_LINE.test(line.trim());

const withoutOptOutLines = (body) => body
  .split("\n")
  .filter((line) => !isOptOutLine(line))
  .join("\n")
  .trimEnd();

export const hasOptOut = (text) => isOptOutLine((text || "").trimEnd().split("\n").pop());

export const withOptOut = (text, enabled) => {
  const body = (text || "").trimEnd();

  if (!enabled) return withoutOptOutLines(body);

  if (hasOptOut(body)) return body;

  const stripped = withoutOptOutLines(body);
  return stripped ? `${stripped}\n${OPT_OUT_TEXT}` : OPT_OUT_TEXT;
};
